import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_debounced_function } from '@/hooks/debounce/use_debounced_function';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import { local_ml_asset_set_current_table_page_settings } from '@/state/diffusion_models_ud/local_ml_asset_set_current_table_page_settings';
import { EPageDiffusionModelsFilterBaseModel } from '../../_base/enums/e_page_diffusion_models_filter_base_models';
import { DiffusionModelsFilterListBaseModel } from '../../_base/filters/diffusion_models_filter_list_base_model';

export function DiffusionModelsFilterListBaseModelUD() {
  const dispatch = use_dispatch();

  const { current_table_page_settings, current_table } = use_slice_ml_asset(['current_table_page_settings', 'current_table']);

  /*
   * EVENTS
   */

  async function on_item_selected(value: string) {
    try_set_base_model_debounced(value);
  }

  /*
   * METHODS
   */

  function try_set_base_model(value: string) {
    let filter_base_model = value === EPageDiffusionModelsFilterBaseModel.ALL ? '' : value;

    if (current_table_page_settings.filter_base_model == filter_base_model) return;

    let current_table_page_settings_new = current_table_page_settings.clone({ filter_base_model });

    dispatch(local_ml_asset_set_current_table_page_settings(current_table_page_settings_new));
  }

  let try_set_base_model_debounced = use_debounced_function(try_set_base_model, CONSTANTS_TIME__client.DEBOUNCE_LOAD_DIFFUSION_MODELS);

  /*
   * RENDERS
   */

  /*
   * HTML
   */
  return <DiffusionModelsFilterListBaseModel {...{ on_item_selected, current_table_page_settings, current_table }} />;
}
